import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import { getCdnUrl } from '../../../helpers';
import {
  stepImageContainer,
  stepImage,
  stepOverlay,
  stepTypography,
} from '../styles/fingo-steps.styles';

function StepCard({ step, activeStep }) {
  const theme = useTheme();
  return (
    <Box sx={stepImageContainer(step.id, activeStep)}>
      <CardMedia
        component="img"
        image={getCdnUrl(step.image)}
        alt={step.imageTitle}
        style={stepImage}
      />
      <Box sx={stepOverlay}>
        <Typography
          variant="large_1"
          color={theme.palette.common.white}
          sx={stepTypography}
        >
          {step.imageTitle}
        </Typography>
        <Typography
          variant="small_3"
          color={theme.palette.common.white}
          fontWeight={500}
          sx={stepTypography}
        >
          {step.description}
        </Typography>
      </Box>
    </Box>
  );
}

StepCard.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    imageTitle: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  activeStep: PropTypes.number.isRequired,
};

export default StepCard;
